import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ variant = "dark", className = "", testId = "site-logo" }) {
  const isDark = variant === "dark";
  const inkPrimary = isDark ? "#0A1F44" : "#FFFFFF";
  const inkMuted = isDark ? "rgba(10, 31, 68, 0.6)" : "rgba(255, 255, 255, 0.75)";

  return (
    <Link to="/" data-testid={testId} className={`flex items-center gap-3 group ${className}`}>
      <img
        src="/brand/evergreen-logo.jpg"
        alt="Evergreen Global Holdings Ltd"
        className="h-12 w-12 object-cover"
        style={{ filter: "none" }}
      />
      <div className="flex flex-col leading-none">
        <span
          className="font-serif text-[19px] font-semibold tracking-tight"
          style={{ color: inkPrimary, lineHeight: 1, letterSpacing: "0.04em" }}
        >
          EVERGREEN
        </span>
        <span
          className="text-[10px] uppercase tracking-[0.26em] mt-1"
          style={{ color: inkMuted, fontWeight: 500 }}
        >
          Global Holdings Ltd
        </span>
      </div>
    </Link>
  );
}
